function toggleAlertState(globalAlert, expanded, noticeMessage, moreInfo) {
  // const toggledProps = expanded ? { height: 'auto', minHeight: '70px' } : { height: '70px', minHeight: 'auto' };
  // globalAlert.css(toggledProps).toggleClass('global-alert--expanded', expanded);
  globalAlert.toggleClass("global-alert--expanded", expanded);
  noticeMessage.slideToggle();
  moreInfo.html(
    expanded
      ? "<p>Less Information</p><span></span>"
      : "<p>More Information</p><span></span>"
  );
  moreInfo.children("span").css({
    transform: `rotate(${expanded ? 270 : 90}deg)`,
    top: expanded ? "-2px" : "0",
  });
}

function setUpAlerts() {
  $(".global-alert").each(function () {
    const globalAlert = $(this);

    const noticeMessage = globalAlert.find(".notice-message");
    const moreInfo = globalAlert.find(".more");

    globalAlert.find(".close").on("click", function () {
      globalAlert.remove();

      // Hacky scroll to trigger re-layout
      $(window).scrollTop($(window).scrollTop() + 1);
      $(window).scrollTop($(window).scrollTop() - 1);

      const alertID = globalAlert.attr("id");
      console.log("Close url:", closeUrl);

      //set cookie closed
    });

    moreInfo.on("click", function (evt) {
      evt.preventDefault();
      const expanded = globalAlert.hasClass("global-alert--expanded");
      toggleAlertState(globalAlert, !expanded, noticeMessage, moreInfo);
    });
  });
}

function fetchActiveAlerts() {
  $.ajax({
    url: "/home/fetchActiveAlerts",
    type: "GET",
    success: function (response) {
      if (response.activeAlerts) {
        $("#js-alert-notice-holder").html(response.activeAlerts);
      }
      setUpAlerts();

      //This will reposition if there is a general notice
      RePositionStickyMenuIfNotice();
      cleanCustomLinks();
    },
    error: function (xhr, status, error) {
      RePositionStickyMenuIfNotice();
      cleanCustomLinks();
      console.error("Error fetching active alerts:", error);
    },
  });
}

function cleanCustomLinks() {
  $(".linkBox-custom").each(function () {
    var content = "";
    content += "<p>";
    content += $(this).text();
    content += "</p><span></span>";
    $(this).empty();
    $(this).append(content);
  });
}

/**
 * Animates the notice away and triggers ajax function to set session state to notice closed
 **/
function setupCloseNotice() {
  if ($(".site-notice").length > 0) {
    var notice = $(".site-notice");
    const stickyMenu = $("header");

    // on click of the close button
    notice.find(".close").on("click", function (evt) {
      // animate the notice away
      notice.slideUp();

      stickyMenu.css("top", "0");
    });
  }
}

function fetchActiveSiteNotice() {
  $.ajax({
    url: "/home/fetchActiveSiteNotice",
    type: "GET",
    success: function (response) {
      if ($("#js-site-notice-holder").length > 0) {
        if (response.siteNotice) {
          $("#js-site-notice-holder").html(response.siteNotice);
        }
        setupCloseNotice();
      }
      fetchActiveAlerts();
    },
    error: function (xhr, status, error) {
      console.error("Error fetching active alerts:", error);
      fetchActiveAlerts();
    },
  });
}

/**
 * Reposition the sticky menu menu to compensate for the height of the notice
 **/
function RePositionStickyMenuIfNotice() {
  if ($(".site-notice").length > 0) {
    var noticeHeight = Math.round($(".site-notice").height());
    var stickyMenu = $("header");
    var stickyMenuBackdrop = $(".header-backdrop");
    var pageTop;

    if ($(".menu__alertswrapper").length > 0) {
      pageTop = $(".menu__alertswrapper");
    } else if ($(".banner").length > 0) {
      pageTop = $(".banner");
    } else {
      pageTop = $(".page__body");
    }

    var stickyMenuOriginalTopPosition = parseInt($(stickyMenu).css("top"));
    var stickyMenuNewTopPostition =
      stickyMenuOriginalTopPosition + noticeHeight;

    // on load - if clear of notice height adopt normal position, otherwise position to add on the height of the notice
    if ($(window).scrollTop() < noticeHeight) {
      stickyMenu.css("top", stickyMenuNewTopPostition);
      stickyMenuBackdrop.css("top", stickyMenuNewTopPostition);
      pageTop.css("margin-top", stickyMenuNewTopPostition);
      // globalAlertbackdrop.css('margin-top', stickyMenuNewTopPostition);
    } else {
      stickyMenu.css("top", stickyMenuOriginalTopPosition);
      stickyMenuBackdrop.css("top", stickyMenuOriginalTopPosition);
      pageTop.css("margin-top", 0);
    }

    // reposition the mobile menu menu to compensate for the height of the notice
    var mobileMenu = $(".menu__panel");
    mobileMenuOriginalMaxHeight = mobileMenu.css("max-height");
    mobileMenuNewMaxHeight =
      parseInt(mobileMenuOriginalMaxHeight) - noticeHeight;
    mobileMenu.css("max-height", mobileMenuNewMaxHeight);

    // change the sticky menu and mobile menu to its original position on close of notice
    $(".site-notice")
      .find(".close")
      .on("click", function (evt) {
        stickyMenu.css("transition", "all .5s");
        stickyMenuBackdrop.css("transition", "all .5s");
        pageTop.css("transition", "all .5s");

        stickyMenu.css("top", stickyMenuOriginalTopPosition);
        stickyMenuBackdrop.css("top", stickyMenuOriginalTopPosition);
        stickyMenuNewTopPostition = stickyMenuOriginalTopPosition;
        pageTop.css("margin-top", 0);
        mobileMenu.css("max-height", mobileMenuOriginalMaxHeight);
        $(".site-notice").addClass("hidden");

        setTimeout(function () {
          stickyMenu.css("transition", "none");
          stickyMenuBackdrop.css("transition", "none");
          pageTop.css("transition", "none");
        }, 500);
      });
  }
}

$(document).ready(function () {
  fetchActiveSiteNotice();
});
